import { Table } from '@heroui/react'

import { RowActions } from '@/components/ui/row-actions'

import type { PosZone } from '../types'
import { branchLabel } from './pos-format'

interface ZonesTableProps {
  zones: PosZone[]
  onEdit: (zone: PosZone) => void
  onDelete: (zone: PosZone) => void
  busyIds?: string[]
}

/**
 * The rooms, and what stands in each.
 *
 * The two counts carry the screen. A zone with no tables is the thing worth
 * noticing here — the floor grid hides empty zones, because half a drawn room
 * reads as an empty one, so this is the only place it shows up.
 */
export function ZonesTable({ zones, onEdit, onDelete, busyIds }: ZonesTableProps) {
  return (
    <Table>
      <Table.ScrollContainer>
        <Table.Content aria-label="Zones">
          <Table.Header>
            <Table.Column id="zone" isRowHeader>
              Zone
            </Table.Column>
            <Table.Column id="outlet">Outlet</Table.Column>
            <Table.Column id="tables">Tables</Table.Column>
            <Table.Column id="seats">Seats</Table.Column>
            <Table.Column id="actions">{/* Row menu */}</Table.Column>
          </Table.Header>

          <Table.Body>
            {zones.map((zone) => (
              <Table.Row key={zone.id} id={zone.id}>
                <Table.Cell>
                  <span className="font-medium">{zone.name}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-accent">{branchLabel(zone.branch)}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className={zone.tables === 0 ? 'text-muted tabular-nums' : 'tabular-nums'}>
                    {zone.tables}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <span className={zone.seats === 0 ? 'text-muted tabular-nums' : 'tabular-nums'}>
                    {zone.seats}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <RowActions
                    label={`zone ${zone.name}`}
                    isBusy={busyIds?.includes(zone.id)}
                    actions={[
                      { id: 'edit', label: 'Rename' },
                      { id: 'delete', label: 'Delete' },
                    ]}
                    onAction={(id) => (id === 'edit' ? onEdit(zone) : onDelete(zone))}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
